import { App, TaasTarifrisikoschluessel } from '@ps20-frontend/frontend-models';
import { VorschadenArt, VorvertragBaustein } from '@ps20/bff-models';

export interface VorvertragVorschaeden {
  appId: App;
  angebotsId?: string;
  anzahlVorschaeden: number;
  vorschaedenArt?: VorschadenArt;
}

export function getAnzahlVorschaeden(
  taasRisikoschluesselList: VorvertragBaustein<TaasTarifrisikoschluessel>[],
  input: TaasTarifrisikoschluessel,
): number {
  const anzVorschaeden = taasRisikoschluesselList?.find(
    value => value.taasTarifrisikoschluessel === input,
  )?.anzahlVorschaeden;
  return anzVorschaeden || 0;
}
